export default {
  data() {
    return {
      realtimeConnection: null,
      realtimeStateHandler: null,
      realtimeWasDown: false,
      realtimeReloadTimer: null,
    }
  },

  methods: {
    watchRealtimeResync(onReconnect) {
      if (typeof window.Echo === 'undefined') return
      if (this.realtimeStateHandler) return

      const { connector } = window.Echo
      const connection = connector && connector.pusher && connector.pusher.connection
      if (!connection) return

      this.realtimeConnection = connection

      this.realtimeStateHandler = state => {
        if (state.current !== 'connected') {
          this.realtimeWasDown = true
          return
        }

        if (!this.realtimeWasDown) return

        this.realtimeWasDown = false
        if (typeof onReconnect === 'function') onReconnect()
      }

      connection.bind('state_change', this.realtimeStateHandler)
    },

    scheduleRealtimeReload(recarregar, esperaMs = 400) {
      if (this.realtimeReloadTimer) clearTimeout(this.realtimeReloadTimer)

      this.realtimeReloadTimer = setTimeout(() => {
        this.realtimeReloadTimer = null
        recarregar()
      }, esperaMs)
    },

    unwatchRealtimeResync() {
      if (this.realtimeReloadTimer) {
        clearTimeout(this.realtimeReloadTimer)
        this.realtimeReloadTimer = null
      }

      if (!this.realtimeConnection || !this.realtimeStateHandler) return

      this.realtimeConnection.unbind('state_change', this.realtimeStateHandler)

      this.realtimeConnection = null
      this.realtimeStateHandler = null
      this.realtimeWasDown = false
    },
  },

  beforeDestroy() {
    this.unwatchRealtimeResync()
  },
}
